/**
 * Erros de validacao da API (400 com `issues`: caminho do campo + motivo) em texto de tela, para QUALQUER formulario (Sessao 37):
 * "<campo> na linha N: <motivo>" quando o caminho passa por uma lista (ex.: `componentes.2.quantidade` -> linha 3) e "<campo>: <motivo>" nos demais.
 * Puro (sem React nem API): o ApiError, o descreverErro e as grades usam o mesmo parser.
 */
export interface IssueApi {
  path: string;
  message: string;
}

/** Rotulo legivel dos campos mais comuns; o que nao esta aqui vira o proprio nome do campo, separado em palavras. */
const ROTULO_CAMPO: Readonly<Record<string, string>> = {
  descricao: 'Descrição',
  quantidade: 'Quantidade',
  unidade: 'Unidade',
  custoUnitario: 'Custo unitário',
  centroCustoId: 'Centro analítico',
  centroConsumoId: 'Centro de consumo',
  componenteItemId: 'Componente',
  perdaValor: 'Valor da perda',
  perdaModo: 'Perda',
  tipo: 'Tipo',
  fornecedorId: 'Fornecedor',
  nome: 'Nome',
  codigo: 'Código',
  email: 'E-mail',
  papel: 'Papel',
  valor: 'Valor',
  data: 'Data',
  validFrom: 'Início da vigência',
};

function humanizar(chave: string): string {
  const palavras = chave.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
  return palavras.charAt(0).toUpperCase() + palavras.slice(1);
}

export interface IssueLegivel {
  /** Nome do campo ja legivel ("Quantidade"); vazio quando o caminho e so um indice. */
  campo: string;
  /** Chave crua do campo (ultimo segmento nao numerico), para a tela marcar a celula/campo. */
  chave: string;
  /** Linha (1-based) quando o caminho passa por um indice de lista; null caso contrario. */
  linha: number | null;
  motivo: string;
}

export function lerIssue(i: IssueApi): IssueLegivel {
  const partes = i.path ? i.path.split('.') : [];
  let linha: number | null = null;
  let chave = '';
  for (const p of partes) {
    if (/^\d+$/.test(p)) linha = Number(p) + 1;
    else chave = p;
  }
  return { campo: chave ? (ROTULO_CAMPO[chave] ?? humanizar(chave)) : '', chave, linha, motivo: i.message };
}

/** "Quantidade na linha 3: Valor inválido" / "Nome: Obrigatório" / só o motivo, sem caminho. */
export function textoIssue(i: IssueApi): string {
  const l = lerIssue(i);
  if (!l.campo) return l.motivo;
  return l.linha !== null ? `${l.campo} na linha ${l.linha}: ${l.motivo}` : `${l.campo}: ${l.motivo}`;
}

/** Lista para a mensagem: "corrija: <campo> na linha N: <motivo>; ...". Vazio sem issues. */
export function resumoIssues(issues: readonly IssueApi[] | undefined): string {
  if (!issues || issues.length === 0) return '';
  return `Corrija: ${issues.map(textoIssue).join('; ')}`;
}
